import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { AppComponent } from './app.component';
import { SignatureComponent } from './views/signature/signature.component';
import { SignaturePadModule } from 'angular2-signaturepad';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RoutingModule } from './routing/routing.module';
import { HttpClientModule } from '@angular/common/http';
import { SignatureService } from './services/signature.service';
import { ApiService } from './services/api.service';
import { QrcodeScannerComponent } from './views/qrcode-scanner/qrcode-scanner.component';
import { ZXingScannerModule } from 'angular-weblineindia-qrcode-scanner';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
@NgModule({
  declarations: [
    AppComponent,
    
    SignatureComponent,
    
    QrcodeScannerComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    SignaturePadModule,
    BrowserAnimationsModule,
    RoutingModule,
    ZXingScannerModule,


  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
  providers: [{provide: LocationStrategy, useClass: HashLocationStrategy},SignatureService],
  bootstrap: [AppComponent]
})
export class AppModule { }
